import styled from "styled-components";
import wireLines from "../../../assets/icons/wire-lines.svg";

export const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ef2c5a;
  border-radius: 10px;
  width: 100%;
  color: white;
  overflow: hidden;
  background-image: url(${wireLines});
  background-size: contain;
  background-position: center;

  @media (min-width: 768px) {
    flex-direction: row;
    max-height: 300px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  text-align: center;
  width: 100%;

  @media (min-width: 768px) {
    padding: 2rem;
    text-align: left;
    max-width: 50%;
    margin-bottom: 0;
  }
`;

export const Title = styled.h1`
  font-family: Athletics, serif;
  font-size: 58px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 1.25rem;
  line-height: 1.2;
  color: #ffff;

  @media (min-width: 768px) {
    font-size: 3.5rem;
  }

  @media (min-width: 1024px) {
    font-size: 4rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 20px;
  font-family: 'Inter';
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 500px;

  @media (min-width: 768px) {
    font-size: 1.125rem;
  }

  @media (min-width: 1024px) {
    font-size: 1.25rem;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  @media (min-width: 768px) {
    width: 50%;
    padding: 2rem;
  }
`;

export const StyledButton = styled.button`
  height: 56px;
  background-color: black;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0 2rem;
  width: 100%;
  font-size: 1rem;
  font-family: 'Inter';
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;

  &:hover {
    background-color: rgba(0, 0, 0, 0.9);
  }

  @media (min-width: 768px) {
    width: 160px;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  max-width: 600px;
`;
